// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"a4bf2f00","454":"67c52a47","526":"0c7eeb51","883":"4f44b94f","966":"0c7eeb51","968":"0c7eeb51"}[chunkId] + ".chunk.css";
};